import { Parser } from "@json2csv/plainjs";
import $ from "jquery";
// import downloadCSV from 'client-side-csv-download'
import loadExternal from "load-external";
import _ from "lodash";
import moment from "moment-timezone";
import url from "url";
import Router from "./router";

export const isNumeric = (data) => {
  return (
    !isNaN(parseFloat(data)) && isFinite(data) && data.constructor !== Array
  );
};

export const isRedacted = (data) => data === "--";

export const downloadCSV = (params) => {
  const $anchor = $("<a></a>");
  $("body").append($anchor);
  $anchor
    .attr({
      href: `data:attachment/csv;charset=utf-8,${encodeURI(params.csvString)}`,
      target: "_self",
      download: `${params.filename}.csv`,
    })[0]
    .click();
  $anchor.remove();
};

export const downloadDataCsv = (data, filename, propHeaders) => {
  // convert our data to a csv string
  const fields = propHeaders || Object.keys(data[0]);
  const json2csvParser = new Parser({ fields });
  const csv = json2csvParser.parse(data);

  // download the csv in the user's browser
  downloadCSV({
    csvString: csv,
    filename,
  });
};

// this should be done in parallel, not sequentially.
// recursively loads files
export const loadExternalMultiple = (files, callback) => {
  if (!_.isArray(files)) {
    asdf;
  }

  loadExternal(files[0], () => {
    if (_.size(files) == 1) {
      callback();
    } else {
      loadExternalMultiple(_.slice(files, 1), callback);
    }
  });
};

export const parseJSON = (json) => {
  if (_.isObject(json)) {
    return json;
  }
  return JSON.parse(json);
};

export const identifyNamedPathFromUrl = (redirectUrl) => {
  if (!redirectUrl) return false;

  let namedPath = "";
  const { pathname } = url.parse(redirectUrl);

  Object.entries(Router.routes).forEach(([k, v]) => {
    if (v == pathname) namedPath = k;
  });

  return namedPath;
};

// March 1 to 7, 2019
// March 1 to April 2, 2021
// December 21, 2019 to January 2, 2020
export const periodLabels = (value) => {
  const startDate = moment(value);
  const endDate = moment(value).add(6, "days");

  if (
    startDate.year() === endDate.year() &&
    startDate.month() === endDate.month()
  ) {
    return `${startDate.format("MMMM D")} to ${endDate.format("D, YYYY")}`;
  }
  if (
    startDate.year() === endDate.year() &&
    startDate.month() !== endDate.month()
  ) {
    return `${startDate.format("MMMM D")} to ${endDate.format("MMMM D, YYYY")}`;
  }

  return `${startDate.format("MMMM D, YYYY")} to ${endDate.format(
    "MMMM D, YYYY"
  )}`;
};

// Helper function to format text by capitalizing and replacing underscores/hyphens with spaces
export const formatDisplayText = (text, options = {}) => {
  if (!text) return text;

  const { handleAcronyms = false, acronymsList = [] } = options;

  if (handleAcronyms && acronymsList.includes(text)) {
    return text.toUpperCase();
  }

  return text
    .replace(/[-_]/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

// Helper function to format dates with customizable format and fallback
export const formatDate = (date, format = "YYYY-MM-DD", fallback = "Never") => {
  if (!date) return fallback;
  const momentDate = moment(date);
  if (!momentDate.isValid()) return fallback;
  return momentDate.format(format);
};
